import { Theme } from '@material-ui/core/styles';

export type FolderColour =
  | 'primary'
  | 'secondary'
  | 'secondary-dark'
  | 'success'
  | 'success-dark'
  | 'warning'
  | 'warning-dark'
  | 'error'
  | 'error-dark';

export const FOLDER_COLOUR_OPTIONS: FolderColour[] = [
  'primary',
  'secondary',
  'secondary-dark',
  'success',
  'success-dark',
  'warning',
  'warning-dark',
  'error',
  'error-dark',
];

export const FOLDER_COLOUR_LABELS: Record<FolderColour, string> = {
  primary: 'Purple',
  secondary: 'Blue',
  'secondary-dark': 'Deep blue',
  success: 'Green',
  'success-dark': 'Dark green',
  warning: 'Amber',
  'warning-dark': 'Dark amber',
  error: 'Pink',
  'error-dark': 'Crimson',
};

const isFolderColour = (value: string): value is FolderColour =>
  (FOLDER_COLOUR_OPTIONS as string[]).includes(value);

export const getFolderColourValue = (theme: Theme, colour?: string | null): string | null => {
  if (!colour || !isFolderColour(colour)) return null;
  switch (colour) {
    case 'primary':
      return theme.palette.primary.main;
    case 'secondary':
      return theme.palette.secondary.main;
    case 'secondary-dark':
      return theme.palette.secondary.dark;
    case 'success':
      return theme.palette.success.main;
    case 'success-dark':
      return theme.palette.success.dark;
    case 'warning':
      return theme.palette.warning.main;
    case 'warning-dark':
      return theme.palette.warning.dark;
    case 'error':
      return theme.palette.error.main;
    case 'error-dark':
      return theme.palette.error.dark;
    default:
      return null;
  }
};
